import React from 'react';

interface IProps {
  children: React.ReactNode;
}

export const LeaveApplicationContent: React.FC<IProps> = ({ children }) => {
  return <>{children}</>;
};
